import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { siteConfig } from "../config/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const { newsletter } = siteConfig;
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/newsletter/subscribe`, { email });
      toast.success(res.data.message || "Suscrito.");
      setDone(true);
    } catch (err) {
      toast.error(
        err?.response?.data?.detail?.[0]?.msg ||
          "Email inválido. Revisa e intenta de nuevo."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="newsletter"
      data-testid="newsletter-section"
      className="relative py-24 sm:py-32"
    >
      <div className="mx-auto max-w-3xl px-6 sm:px-10">
        <div className="glass rounded-[2rem] p-8 sm:p-14 text-center relative overflow-hidden">
          <div className="absolute -top-20 -left-20 blob blob-violet animate-float-slow" style={{ width: 260, height: 260 }} />
          <div className="absolute -bottom-20 -right-20 blob blob-pink animate-float-slower" style={{ width: 300, height: 300 }} />

          <div className="relative">
            <span className="inline-block text-[0.7rem] tracking-[0.35em] uppercase text-[color:var(--yicel-violet)] font-semibold">
              Newsletter
            </span>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl text-ink" data-testid="newsletter-title">
              {newsletter.title}
            </h2>
            <p className="mt-4 max-w-lg mx-auto text-base text-[color:var(--yicel-muted)]">
              {newsletter.description}
            </p>

            {done ? (
              <div className="mt-10 inline-flex items-center gap-3 rounded-full bg-[#B2A4FF]/15 px-6 py-3"
                   data-testid="newsletter-success">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#B2A4FF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                <span className="text-sm text-ink">Estás dentro. Gracias.</span>
              </div>
            ) : (
              <form
                onSubmit={submit}
                className="mt-10 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
                data-testid="newsletter-form"
              >
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@email.com"
                  data-testid="newsletter-input-email"
                  className="flex-1 bg-white/80 border border-[color:var(--yicel-violet)]/30 rounded-full px-6 py-4 outline-none focus:ring-2 focus:ring-[color:var(--yicel-violet)]/60 transition text-sm"
                />
                <button
                  type="submit"
                  disabled={loading}
                  data-testid="newsletter-submit"
                  className="rounded-full bg-[#2D2A32] text-white px-8 py-4 text-sm tracking-wide hover:bg-[#B2A4FF] transition-all duration-300 disabled:opacity-60"
                >
                  {loading ? "Enviando…" : "Únete al viaje"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
